import { render, staticRenderFns } from "./IconCustomize.vue?vue&type=template&id=afac6326&"
import script from "./IconCustomize.vue?vue&type=script&lang=js&"
export * from "./IconCustomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afac6326')) {
      api.createRecord('afac6326', component.options)
    } else {
      api.reload('afac6326', component.options)
    }
    module.hot.accept("./IconCustomize.vue?vue&type=template&id=afac6326&", function () {
      api.rerender('afac6326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCustomize.vue"
export default component.exports